import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next'
import configData from '../../../temp/config';
import '../gender-predictor-css/search-type-drop-down.css';

const MonthsDropDown = (props) => {

    const [showItems, setShowItems] = useState(false)
    const [defaultSearchType, setDefaultSearchType] = useState('Select Month')
    const { t } = props;

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        let c_mon = []
        if (props.currentMonthCycle.selectedMonth === 0) {
            const today = new Date()
            let currentMonth = today.toLocaleString('default', { month: 'long' });
            c_mon = props.monthOptions.filter((item, index) => {
                if (item.fields.name.value === currentMonth) {
                    return item;
                }
            })
        } else {
            if (props.currentMonthCycle.selectedMonth != 'Select Month') {
                c_mon = props.monthOptions.filter((item, index) => {
                    if (item.fields.name.value === props.currentMonthCycle.selectedMonth.name.value) {
                        return item;
                    }
                })
            }
        }
        if (props.currentMonthCycle.selectedMonth != 'Select Month') {
            setDefaultSearchType(c_mon[0].fields.name.value)
            props.handleChange(c_mon[0].fields)
        }
    }, [])

    const handleClickOutside = (event) => {
        console.log(event.target.className)
        if (event.target.className === 'select-box--selected-item-close' || event.target.className === 'slect-box-selected-item-text-close' ||
            event.target.className === 'select-box--arrow-up fa fa-angle-up') {
            setShowItems(true)
        }
        else if (event.target.className === 'select-box--arrow-down') {
            setShowItems(false)
        }
        else if (event.target.className === 'select-box--arrow-up') {
            setShowItems(true)
        } else {
            setShowItems(false)
        }
    }

    const dropDown = () => {
        showItems ? setShowItems(false) : setShowItems(true)
    }

    const closeDropDown = () => {
        setShowItems(false)
    }

    const selectItem = (item) => {
        setDefaultSearchType(item.fields.name.value)
        setShowItems(false)
        props.handleChange(item.fields)
    }

    return (
        <div className="nameSearchFieldDropdown">
            <div className="custom-select-dropdown">

                <div className="select-box--box">
                    <div className="select-box--container"  >
                        <div className={!showItems ? "select-box--selected-item" : 'select-box--selected-item-close'} onClick={dropDown}>
                            <div className="slect-box-selected-item-text-div" >
                                <span className={!showItems ? "slect-box-selected-item-text" : "slect-box-selected-item-text-close"}>{defaultSearchType}</span>
                            </div>
                            <div className="select-box--arrow" name="select-box--name">
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div>
                        </div>
                        {/* <div className="select-box--arrow" name="select-box--name" onBlur={closeDropDown}>
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div> */}
                        <div style={{ display: showItems ? 'block' : 'none' }}
                            className="select-box--items gender-month-wrapper"
                        >

                            {
                                props.monthOptions.map((item, index) => {
                                    return (

                                        <div
                                            key={index}
                                            onClick={() => selectItem(item)}
                                            className={defaultSearchType === item.fields.name.value ? 'selected' : ''}
                                        ><p className="nameListItem">
                                                {item.fields.name.value}
                                            </p>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
};

export default withTranslation()(MonthsDropDown);